import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { MeasGroup, MeasGroupListResponse, MeasGroupQueryParams } from '../models/meas-group.model';
import { MeasGroupGateway } from '../usecases/meas-group.gateway';

@Injectable()
export class MeasGroupService extends MeasGroupGateway {
  constructor(private _http: HttpClient) {
    super();
  }

  listMeasGroups(params: MeasGroupQueryParams): Observable<MeasGroupListResponse<MeasGroup>> {
    return this._http.get<MeasGroupListResponse<MeasGroup>>('api/vgs/meas-groups', { params });
  }
}
